import { useGetIdentity, useRecordContext } from 'react-admin';
import { Buyer } from '../types';

export const BuyerName = ({ buyer }: { buyer?: Buyer }) => {
    const { identity, isPending } = useGetIdentity();
    const buyerFromContext = useRecordContext<Buyer>();
    const finalBuyer = buyer || buyerFromContext;
    if (isPending || !finalBuyer) return null;
    return finalBuyer.id === identity?.id
        ? 'Você'
        : `${finalBuyer.nome_razao}`;
};
